import { library, config } from '@fortawesome/fontawesome-svg-core';
import {
  faBellConcierge,
  faChartMixed,
  faCircleDollar,
  faCircleExclamation,
  faCircleInfo,
  faClock,
  faCoin,
  faCoins,
  faFaceDisguise,
  faFileInvoiceDollar,
  faFileLines,
  faGameConsoleHandheld,
  faGauge,
  faGear,
  faGrid2,
  faImage,
  faMoneyBill,
  faPenPaintbrush,
  faRadar,
  faSquareCode,
  faSquarePollHorizontal,
  faSquareSliders,
  faStar,
  faUpRightFromSquare,
  faUserUnlock,
} from '@fortawesome/pro-solid-svg-icons';

export default defineNuxtPlugin(nuxtApp => {
  //todo: maybe it's possible to replace this with utilizing iconify after adding the nuxt ui package.

  // Needed for database provided icon names:
  // - app config item type data & link configuration
  library.add(
    faBellConcierge,
    faChartMixed,
    faCircleDollar,
    faCircleExclamation,
    faCircleInfo,
    faClock,
    faCoin,
    faCoins,
    faFaceDisguise,
    faFileInvoiceDollar,
    faFileLines,
    faGameConsoleHandheld,
    faGauge,
    faGear,
    faGrid2,
    faImage,
    faMoneyBill,
    faPenPaintbrush,
    faRadar,
    faSquareCode,
    faSquarePollHorizontal,
    faSquareSliders,
    faStar,
    faUpRightFromSquare,
    faUserUnlock
  );

  config.autoAddCss = false;
});
